import colors from './colors'

// Defining your theme palette and typography as usual
export const {
  primaryColor,
  secondaryColor,
  white,
  greySoft,
  grey,
  greyMid,
  greyDark,
  grey616161,
  greyDarker,
  greyDarkest,
  greyDarkestTransparent,
  black,
  slate,
  slateDark,
  greenSofter,
  greenSoft,
  green,
  purpleSoft,
  blueSoft,
  redSoft,
  pinkSoft,
  yellowSoft,
  petrol,
  petrolActive
} = colors

export const palette = {
  ...colors,
  common: { black, white },
  type: 'light',
  primary: {
    main: primaryColor,
    light: 'rgb(77, 171, 245)',
    dark: 'rgb(23, 105, 170)',
    contrastText: '#fff'
  },
  secondary: {
    main: secondaryColor,
    light: 'rgb(247, 51, 120)',
    dark: 'rgb(171, 0, 60)',
    contrastText: black
  },
  error: {
    light: '#e57373',
    main: '#f44336',
    dark: '#d32f2f',
    contrastText: '#fff'
  },
  warning: {
    light: '#ffb74d',
    main: '#ff9800',
    dark: '#f57c00',
    contrastText: primaryColor
  },
  info: {
    light: '#64b5f6',
    main: primaryColor,
    dark: '#1976d2',
    contrastText: '#fff'
  },
  success: {
    light: '#81c784',
    main: '#4caf50',
    dark: '#388e3c',
    contrastText: primaryColor
  },
  grey: {
    50: greySoft,
    100: grey,
    200: greyMid,
    300: greyDark,
    400: greyDarker,
    500: greyDarkest,
    600: slate,
    700: slateDark,
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A500: greyDarkestTransparent,
    A700: grey616161
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  text: {
    primary: primaryColor,
    secondary: '#4b5563',
    disabled: greyDarkest,
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#fff',
    default: '#fff',
    level2: '#f5f5f5',
    level1: '#fff'
  },
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    disabled: greyMid,
    muiDisabled: '#f3f4f6',
    disabledBackground: green,
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  },
  purpleSoft,
  blueSoft,
  greenSoft,
  greenSofter,
  pinkSoft,
  redSoft,
  yellowSoft,
  petrol,
  petrolActive
}
